import makeApiRequest from './makeApiRequest';

const findEwallets = () => {
	const getApiRequest = makeApiRequest('GET');

	const retrieveEwallets = async (apiBase: string) => getApiRequest(`${apiBase}/api/wallets`, {});
	return [retrieveEwallets];
};

export default findEwallets;
